<template>
  <div>
  <c-summary-navbar :userName="eipUserName" :protalName="'Reports'" @userLogout="logout()" />
      <w-loading-spinner :loadSpinner="loading" />
      <div style="text-align:left; padding: 10px 20px;">     
      <button class="top-btn" :class="currentview=='grievance' ? 'btn btn-primary':'btn btn-outline-secondary'" 
      @click="getReports('grievance')">Grievance Reports</button><!---->
       <button class="top-btn" :class="currentview=='partner' ? 'btn btn-primary':'btn btn-outline-secondary'" 
      @click="getReports('partner')">Partner Reports</button><!---->
      </div>
<div id="main-wrapper" v-if="allowViewReportsDashboard">
  <div style="position: absolute;right: 20px;top: 100px;font-size: 15px;color: brown;" v-if="currentview=='grievance'">
    *Note: Draft Grievances are not shown in visualizations</div>
  <div class="row" v-if="currentview=='partner'" style="padding: 20px;font-size: 16px;">
      Nothing to show now..!  Come back later    
  </div>
  <div class="row" v-if="currentview=='grievance'">
    <div class="col-2">
      <div class="field-heads">Select Company:</div>
      <select v-model="grCompanyCode" class="form-control sl" 
      ><!--@change="getBussinessVerticals(grCompanyCode)"-->
        <!--option :value="0">Select Company</option-->
        <option :value="1">L&T Construction</option>
        <option :value="8">L&T GeoStructure</option>
      </select>
    </div>
    <div class="col-2">
      <div class="field-heads">Select IC:</div>
      <select v-model="grIcCode" class="form-control sl" 
      :class="bussinessVerticalList.length==0 || grCompanyCode==0 ?'disabled':''"
      @change="onIcChange(grIcCode)">
        <option :value="0">All</option>
        <option v-for="i in bussinessVerticalList" :key="i" :value="i.value">{{i.text}}</option>
      </select>
    </div>
    <div class="col-2">
      <div class="field-heads">Select Grievance Status:</div>
      <select v-model="grStatus" class="form-control sl" :class="grCompanyCode==0?'disabled':''">
        <option :value="0">All</option>
        <option v-for="i in grStatusList" :key="i" :value="i.value">{{i.text}}</option>
      </select>
    </div>
    <div class="col-2">
      <div class="field-heads">Select Grievance Type:</div>
      <select v-model="grType" class="form-control sl" :class="grCompanyCode==0?'disabled':''">
        <option :value="0">All</option>
        <option v-for="i in grTypeList" :key="i" :value="i.value">{{i.text}}</option>
      </select>
    </div>
     
    <div class="col-2" :class="grCompanyCode==0?'disabled':''">
      <div class="field-heads">Created Date: {{(grSelectedDateRange[0]==null || grSelectedDateRange[1]==null) ? '(All time)' : ''}}</div>
    <date-picker
      v-model="grSelectedDateRange"
      range
      :lang="'en'"
      confirm
      @confirm="selectedgrDate($event)"
      :format="'D-MMM-YYYY'"
      :shortcuts="false"
      class="w-100"
    ></date-picker>
    </div>
    <div class="col-2" style="text-align:center;">
      <div style="user-select:none;">&nbsp;</div>
    <button @click="downloadGrievanceReportsFile()" style="line-height: 30px;"
    :class="grCompanyCode==0?'disabled':''" class="btn down-btn">Download Report 
    <span style="font-size:24px;font-weight:bold;"> &#8628;</span>
  </button> </div>
  <div class="col-12" style="padding:0px 20px 20px 20px;background: #f3f3f3;margin-top: 25px;border-top: 1px solid #5c5c5c !important;">
    <div v-if="grIcCode==0" class="time-dis-wrap">
      Average Time To Close a Grievance ( {{grCompanyCode==8?'L&T GeoStructure':''}} {{grCompanyCode==1?'L&T Construction':''}}) : 
      <span class="time-dis">{{averageTimeToClose}}</span></div>
  <div v-if="grIcCode!=0" class="time-dis-wrap">
    Average Time To Close a Grievance ({{bussinessVerticalList.filter(x=>x.value==grIcCode)[0].text}}) : 
    <span class="time-dis">{{averageTimeToClose}}</span></div>
   <div class="col-12" style="display: inline-block;margin-bottom:15px;" v-if="grIcCode==0">
  <div v-if="grIcCode==0" style="font-weight: bold;font-size:16px;
  padding-bottom:5px;">Comprehensive Month wise Grievances for past year (All ICs) - 
  {{grCompanyCode==8?'L&T GeoStructure':''}} {{grCompanyCode==1?'L&T Construction':''}}</div>
    <div v-if="grIcCode!=0" style="font-weight: bold;font-size:16px;">{{bussinessVerticalList.filter(x=>x.value==grIcCode)[0].text}}  - Comprehensive Month wise Grievances for past year</div>
   <GChart
    type="LineChart"
    :data="monthWiseGrievanceCount"
    :options="monthWiseGrievanceCountOptions"
    :resizeDebounce="500"
  />  
</div>
<div class="col-8" style="display: inline-block;margin-bottom:15px;">
  <div style="font-weight: bold;font-size:16px;
  padding-bottom:5px;">Comprehensive IC wise Grievances (All ICs) - 
  {{grCompanyCode==8?'L&T GeoStructure':''}} {{grCompanyCode==1?'L&T Construction':''}}</div>
   <GChart
    type="ColumnChart"
    :data="chartComprehensiveICWiseStatuses"
    :options="comprehensiveDataOptions"
    :resizeDebounce="500"
  />  
</div>
<div class="col-4" style="display: inline-block;margin-bottom:15px;">
  <div v-if="grIcCode==0" style="font-weight: bold;font-size:16px;
  padding-bottom:5px;">Category wise split Count (All ICs)</div>
  <div v-if="grIcCode!=0" style="font-weight: bold;font-size:16px;">{{bussinessVerticalList.filter(x=>x.value==grIcCode)[0].text}}  - Category wise split count</div>
   
   <GChart
    type="PieChart"
    :data="pieCountWiseData"
    :options="pieDataOptions"
    :resizeDebounce="500"
  />  
</div>
<div class="col-6" style="display: inline-block;margin-bottom:15px;">
  <div v-if="grIcCode==0" style="font-weight: bold;font-size:16px;
  padding-bottom:5px;">Overall Grievances - Status wise Count (All ICs)</div>
  <div v-if="grIcCode!=0" style="font-weight: bold;">{{bussinessVerticalList.filter(x=>x.value==grIcCode)[0].text}}  - Status wise grievances Count</div>
   <GChart
    type="ColumnChart"
    :data="chartStatusWiseData"
    :options="chartchartStatusWiseDataOptions"
    :resizeDebounce="500"
    :isStacked="true"
  />
</div>
<div class="col-6" style="display: inline-block;margin-bottom:15px;">
  <div v-if="grIcCode==0" style="font-weight: bold;font-size:16px;
  padding-bottom:5px;">Overall Grievances - Reason wise Count (All ICs)</div>
  <div v-if="grIcCode!=0" style="font-weight: bold;">{{bussinessVerticalList.filter(x=>x.value==grIcCode)[0].text}}  - Reason wise grievances Count</div>
   <GChart
    type="ColumnChart"
    :data="chartReasonWiseData"
    :options="chartchartReasonWiseDataOptions"
    :resizeDebounce="500"
    :isStacked="true"
  />
</div>
</div>

  </div>     
   </div>
   </div>
</template>

<script>
import SummaryNavbar from "../components/summary/summaryNavbar";
import LoadingSpinner from "../widgets/LoadingSpinner";
import { SummaryServices } from "../services/summaryService";
const summaryService = new SummaryServices();
import { OnBoardingServices } from "../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import { AESService } from "../services/AES.js";
let aesService = new AESService();

import DatePicker from "vue2-datepicker";
export default {
  components: {
    "w-loading-spinner": LoadingSpinner,
    "c-summary-navbar": SummaryNavbar,
    DatePicker
  },
  data() {
    return {
      allowViewReportsDashboard:false,
      icComprehensiveList:[],
      icCategoryCountList:[],
      averageTimeToClose:'NA',
      grTypeList:[],
      icStatusList:[],
      icReasonsList:[],
      grCompanyCode:1,
      grType:'0',
      grIcCode:'0',
      grStatus:'0',
      grSelectedDateRange:'',
      bussinessVerticalList:[],
      grStatusList:[{"text":"Grievance Raised by Vendor","value":4},{"text":"Forwarded to next nevel by allocator","value":10},
      {"text":"Reviewed by the reviewer","value":13},{"text":"Marked Resolved and sent to the vendor ","value":8},
      {"text":"Reopened by vendor","value":11},{"text":"Closed by vendor","value":9},{"text":"SentBack by allocator to vendor","value":2}],
      currentview:'grievance',
      loading: false,
      companyCodeToPass:'',
      originalArray:[],
      frRolesList:[],
      traceData: [],
      docSearch: "",
      answerNumber: "",
      userId: "",
      userCode: "",
      eipUserName: "",
      auditNo: "",
      companyCode: "",
      overAllremarks: "",
      failureModal: false,
      triggerModal: false,
      successModal: false,
      alertModal: false,
      lastResponse: "",
     
      roleName: [],
      pieCountWiseData:[],
      pieDataOptions:{
          title: 'Category wise Count',
          is3D: true,
        },
      chartStatusWiseData: [],
      chartchartStatusWiseDataOptions: {
        chart: {
          title: 'Status wise count',
          subtitle: 'Status wise count',
        },
        fontSize: 14,
        colors:['#f4b400'],
        backgroundColor:'#ffffff50',
        legend: {position: 'none', textStyle: {color: 'black', fontSize: 14}},
        annotations:{
          alwaysOutside	: false
          }


      }, 
      chartReasonWiseData: [],
      chartchartReasonWiseDataOptions: {
        chart: {
          title: 'Reason wise count',
          subtitle: 'Reason wise count',
        },
        fontSize: 14,
        colors:['#4b96d0'],
        backgroundColor:'#ffffff50',
        legend: {position: 'none', textStyle: {color: 'legend', fontSize: 14}},
        annotations:{
          alwaysOutside	: false
          }
      }, 
      monthWiseGrievanceCount:[],
      monthWiseGrievanceCountOptions:{
        chart: {
          title: 'Comprehensive Month wise Grievances for past year'
        },
        series: {
            0: { color: '#1c91c0' }
        },
         lineWidth: 3,
        legend: {position: 'top', textStyle: {color: 'legend', fontSize: 14}},
      },
      chartComprehensiveICWiseStatuses: [],
      comprehensiveDataOptions: {
        chart: {
          title: 'IC wise count',
          subtitle: 'IC wise count',
        },
        fontSize: 14,
        colors:['#990099','#f4b400','#3266cc','#db4437','#f4b400','#64c494','#313950'],        
        isStacked:"true",
        backgroundColor:'#ffffff50',
        legend: {position: 'top', textStyle: {color: 'legend', fontSize: 14}},
        annotations:{
          alwaysOutside	: false
          }
      }, 
      encryptsecret: atob(process.env.VUE_APP_S_S),
    };
  },
  watch: {
    'grCompanyCode': function(newVal, oldVal) {
      this.onCompanyChange(this.grCompanyCode)
    }
  },
  created() {
    var self = this
    
    this.decryptfunction();
    this.getReasonForVariation();
    this.getBussinessVerticals(1);
  },
  computed: {},
  methods: {    
    onCompanyChange(grIcCode){ 
      this.grIcCode = '0'    
      this.grType = '0'     
      this.grStatus = '0'
      this.bussinessVerticalList=[]
      OnBoardingService.getBussinessVertical(this.grCompanyCode).then(resp => {
        resp.response.forEach(project => {
          if(this.bussinessVerticalList.filter(x=>x.text==project.longDesc).length==0){
          this.bussinessVerticalList.push({
            text: project.longDesc,
            value: project.id.cedCode
          });        
          }
          });
      this.getGrievanceMetricsIcWiseStatus(grIcCode)
      this.getGrievanceMetricsIcWiseReasons(grIcCode)
      this.getGrievanceMetricsOthers(grIcCode)
      this.getGrievanceMonthWise(grIcCode);
      this.getGrievanceMetricsIcsandStatus();      
      });
    },
    onIcChange(grIcCode){
      this.grStatus='0'
      this.grType='0'
      this.getGrievanceMetricsIcWiseStatus(grIcCode)
      this.getGrievanceMetricsIcWiseReasons(grIcCode)
      this.getGrievanceMonthWise(grIcCode);
      this.getGrievanceMetricsOthers(grIcCode)
      this.getGrievanceMetricsIcsandStatus();
    },
    getReasonForVariation() {
      this.grTypeList=[]
      OnBoardingService.getVarReason().then(res => {
        res.response.forEach(varReason => {
          this.grTypeList.push({
            text: varReason.displayName,
            value: varReason.miscTypeDetailsCode
          });
        });
      });
    },
    getReports(type){
      this.currentview = type
      if(type=='grievance'){
      this.grIcCode = '0'    
      this.grType = '0'     
      this.grStatus = '0'
        this.getGrievanceMetricsIcWiseStatus(0)
        this.getGrievanceMetricsIcWiseReasons(0)
        this.getGrievanceMetricsOthers(0)
        this.getGrievanceMonthWise(0)
        this.getGrievanceMetricsIcsandStatus()
      }
    },    
    selectedgrDate(e){
      console.log(e)
    },
    dhm (ms) {
      const days = Math.floor(ms / (24*60*60*1000));
      const daysms = ms % (24*60*60*1000);
      const hours = Math.floor(daysms / (60*60*1000));
      const hoursms = ms % (60*60*1000);
      const minutes = Math.floor(hoursms / (60*1000));
      const minutesms = ms % (60*1000);
      const sec = Math.floor(minutesms / 1000);
      return days + " d : " + hours + " h : " + minutes + " m : " + sec + " s";
    },
    getGrievanceMetricsOthers(icCode){
      var self = this
      self.chartStatusWiseData = []
      self.averageTimeToClose = 'NA'
      summaryService.getGrievanceMetricsOthers(this.grIcCode,this.grCompanyCode)
        .then(res => {
          console.log(res)
          if(res.response.caterogyWiseCount){
            self.icCategoryCountList=res.response.caterogyWiseCount
            if(res.response.averageTimeToClose[0]){
              self.averageTimeToClose=self.dhm(res.response.averageTimeToClose[0])
            }
            for(var i=0; i<self.icCategoryCountList.length; i++) {
              var n = self.icCategoryCountList[i]
              if(n[0]==2){
                n[0]='Supplier'
              }if(n[0]==3){
                n[0]='Service Provider'
              }if(n[0]==5){
                n[0]='Customer'
              }
              self.icCategoryCountList[i] = n
            }
            var x= ["Category","Count of Grievances"]
            self.icCategoryCountList.splice(0,0,x)
            self.pieCountWiseData=self.icCategoryCountList
            
          } else {  
            self.icCategoryCountList=[]          
            self.icCategoryCountList.push(["Category","Count of Grievances"])
            self.icCategoryCountList.push(['No Data', 0])
            self.pieCountWiseData=self.icCategoryCountList
          }
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    getGrievanceMetricsIcWiseStatus(icCode) {
      var self = this
      self.chartStatusWiseData = []
      summaryService.getGrievanceMetricsIcWiseStatus(icCode,this.grCompanyCode)
        .then(res => {
          console.log(res)
          if(res.response){
            self.icStatusList=[]
            var x= []
            self.icStatusList.push(["Status","Count of Grievances for each status",{role:'annotation'},{role:'style'}])
            for(var i=0;i<res.response.length;i++) {
              if(res.response[i][0]!=7){
              x=[]              
              x[0]=self.getStatusText(res.response[i][0])
              x[1]=res.response[i][1]
              x[2]=res.response[i][1]
              x[3]=self.getColorCode(res.response[i][0])
              self.icStatusList.push(x)
              }
            }
            if(self.icStatusList.length ==1) {              
              self.icStatusList.push(['No Data', 0,0,0])
            }
            self.chartStatusWiseData=self.icStatusList
          } else {  
            self.icStatusList=[]          
            self.icStatusList.push(["Status","Count of Grievances for each status",{role:'annotation'},{role:'style'}])
            self.icStatusList.push(['No Data', 0,0,0])
            self.chartStatusWiseData=self.icStatusList
          }
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    
    getGrievanceMonthWise(icCode){
      var self = this
      self.monthWiseGrievanceCount = []
      summaryService.getGrievanceMonthWise(icCode,this.grCompanyCode)
        .then(res => {
          if(res.response) {
            var x= []
            x.push(["Timeline","Number of Grievances for each month"])
              for(var i=0;i<res.response.length;i++) {  
               x.push([self.getMonthName(res.response[i][0])+' '+res.response[i][1], res.response[i][2]])
              }
            self.monthWiseGrievanceCount = x
          } else {  
            self.monthWiseGrievanceCount=[]          
            self.monthWiseGrievanceCount.push(["Timeline","Count of Grievances for each month"])
            self.monthWiseGrievanceCount.push([0,0])
          }
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    getGrievanceMetricsIcWiseReasons(icCode){
      var self = this
      self.chartReasonWiseData = []
      summaryService.getGrievanceMetricsIcWiseReasons(icCode,this.grCompanyCode)
        .then(res => {
          console.log(res)
          if(res.response){
            self.icReasonsList=[]
            var x= []
            self.icReasonsList.push(["Reason Type","Count of Grievances for each reason",{role:'annotation'}])
            for(var i=0;i<res.response.length;i++) {  
              if(self.grTypeList.filter(x=>x.value == res.response[i][0]).length > 0){            
               x=[]              
               x[0]=self.grTypeList.filter(x=>x.value == res.response[i][0])[0].text
               x[1]=res.response[i][1]
               x[2]=res.response[i][1]
               self.icReasonsList.push(x)     
              }         
            }
            if(self.icReasonsList.length ==1) {              
              self.icReasonsList.push(['No Data', 0,0])
            }
            self.chartReasonWiseData=self.icReasonsList
          } else {  
            self.icReasonsList=[]          
            self.icReasonsList.push(["Reason Type","Count of Grievances for each reason",{role:'annotation'}])
            self.icReasonsList.push(['No Data', 0,0])
            self.chartReasonWiseData=self.icReasonsList
          }
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    getGrievanceMetricsIcsandStatus(){
      var self = this
      self.chartComprehensiveICWiseStatuses = []
      summaryService.getGrievanceMetricsIcsandStatus(this.grCompanyCode)
        .then(res => {
          console.log(res)
          if(res.response){
            self.icComprehensiveList=[]
            var x= []            
            var statusTmpList=[], icTmpList=[]
            self.icComprehensiveList.push(["IC",{role:'annotation'}])
            for(var i=0;i<res.response.length;i++) {
              if(self.bussinessVerticalList.filter(x=>x.value == res.response[i][0]).length>0){            
               x=[]
               x[0]=self.bussinessVerticalList.filter(x=>x.value == res.response[i][0])[0].text
               x[1]=self.getStatusText(res.response[i][1])
               x[2]=res.response[i][2]
               statusTmpList.indexOf(x[1])==-1  && statusTmpList.push(x[1])
               icTmpList.indexOf(x[0])==-1 && icTmpList.push(x[0])
               if(res.response[i][1] != 19){ // omit drafts
               self.icComprehensiveList.push(x)
               }
              }
            }
            self.icComprehensiveList[0].splice(1, 0, ...statusTmpList)
            var items= [], item=[]
            for(var k=0; k<icTmpList.length; k++) {
            for(var z=0; z<statusTmpList.length; z++) {            
                item.indexOf(icTmpList[k])==-1 && item.push(icTmpList[k])                          
                  var ismatch = self.icComprehensiveList.filter(x=>icTmpList[k]==x[0] &&
                  x[1]==statusTmpList[z])
                   if(ismatch.length>0) {
                       item.push(ismatch[0][2])
                    } else {
                       item.push(0);
                    }                   
               }       
                item.push('')
                var short= self.getICShort(item[0])
                //item[0] = short
                item[0]=self.getICShort(item[0])
                items.push(item)
                item=[]
            }
            console.log(items)
            self.icComprehensiveList.splice(1)
            self.icComprehensiveList.splice(1, 0, ...items)


            console.log(self.icComprehensiveList)

            if(self.icComprehensiveList.length ==1) {
              self.icComprehensiveList.push(['No Data',0,0])
            }
            self.chartComprehensiveICWiseStatuses=self.icComprehensiveList
          } else {  
            self.icComprehensiveList=[] 
            self.icComprehensiveList.push(["IC wise",'No Data',{role:'annotation'}])
            self.icComprehensiveList.push(['No Data',0,0])
            self.chartComprehensiveICWiseStatuses=self.icComprehensiveList
          }
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    downloadGrievanceReportsFile(){
      var sD = this.grSelectedDateRange[0]
      var eD = this.grSelectedDateRange[1]
      var fsD= sD ? sD.getFullYear() + '-' + (parseInt(sD.getMonth())+1) + '-' + sD.getDate() : null      
      var feD= eD ? eD.getFullYear() + '-' + (parseInt(eD.getMonth())+1) + '-' + eD.getDate() : null
      if(fsD){
      fsD=fsD.split('-').map(x=>x.length==1 ? '0'+x : x).join('-') + ' 00:00'
      } 
      if(feD){
      feD=feD.split('-').map(x=>x.length==1 ? '0'+x : x).join('-') + ' 00:00'
      }
      
     var data={
        companyCode: this.grCompanyCode && this.grCompanyCode != '0' ? this.grCompanyCode : null,
        icCode: this.grIcCode && this.grIcCode != '0' ? this.grIcCode : null,
        statusCode: this.grStatus && this.grStatus != '0' ? this.grStatus : null,
        reasonTypeCode: this.grType && this.grType != '0' ? this.grType : null,
        startDate: fsD,
        endDate: feD
      }
     // window.alert(JSON.stringify(data))
      summaryService.downloadGrievanceList(data)
        .then(res => {
        })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage;
              this.alertModal = true;
        });
    },
    getMonthName(m){
      var i = m-1
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      return monthNames[i];
    },
    getColorCode(statusCode){
      if (statusCode == 1) {
      return 'green';
      } else if (statusCode == 2) {
      return '#2196f3';
      } else if (statusCode == 3) {
      return 'Rejected';
      } else if (statusCode == 4) {
      return 'darkorange';
      } else if (statusCode == 5) {
      return 'yellow';
      } else if (statusCode == 6) {
      return 'greenyellow';
      } else if (statusCode == 7) {
      return 'yellow';
      } else if (statusCode == 8) {
      return 'limegreen';
      } else if (statusCode == 9) {
      return 'greenyellow';
      } else if (statusCode == 10) {
      return 'lightcoral';
      } else if (statusCode == 11) {
      return 'red';
      } else if (statusCode == 13) {
      return 'blueviolet';
      }
    },
    getICShort(desc){
      if(desc.indexOf('Heavy Civil')>-1){
        return 'HCI'
      }else if(desc.indexOf('Metall')>-1){
        return 'MMH'
      }else if(desc.indexOf('Buildings')>-1){
        return 'B&F'
      }else if(desc.indexOf('NXT')>-1){
        return 'L&T NXT'
      }else if(desc.indexOf('Divisional')>-1){
        return 'DC'
      }else if(desc.indexOf('Transportation')>-1){
        return 'TIIC'
      }else if(desc.indexOf('Water')>-1){
        return 'WET IC'
      }else if(desc.indexOf('Power')>-1 && desc.indexOf('Domestic')>-1){
        return 'PT&D Domestic'
      }else if(desc.indexOf('Power')>-1 && desc.indexOf('International')>-1){
        return 'PT&D International'
      }else if(desc.indexOf('Smart')>-1){
        return 'SWC'
      }else if(desc.indexOf('GeoStructures')>-1){
        return 'Geo'
      }else {
        return desc
      }
    },
    getStatusText(statusCode){
      if (statusCode == 1) {
      return 'Approved';
      } else if (statusCode == 2) {
      return 'SendBack';
      } else if (statusCode == 3) {
      return 'Rejected';
      } else if (statusCode == 4) {
      return 'Requested';
      } else if (statusCode == 5) {
      return 'PartialApproved';
      } else if (statusCode == 6) {
      return 'AutoCancel';
      } else if (statusCode == 7) {
      return 'Created';
      } else if (statusCode == 8) {
      return 'Resolved';
      } else if (statusCode == 9) {
      return 'Closed';
      } else if (statusCode == 10) {
      return 'Forwarded';
      } else if (statusCode == 11) {
      return 'Reopened';
      } else if (statusCode == 13) {
      return 'Reviewed';
      }
    },
    getBussinessVerticals(comp) {
      this.bussinessVerticalList=[]
      var self = this
      /*if(comp!=0){
      OnBoardingService.getBussinessVertical(comp).then(resp => {
        resp.response.forEach(project => {
          this.bussinessVerticalList.push({
            text: project.longDesc,
            value: project.id.cedCode
          });
        });
      });
      }*/
      self.onCompanyChange(self.grIcCode)
    },
    getRoleName(frCode) {
      if (frCode == 0)
      {
        return 'Partner'
      }
      return this.frRolesList.filter(x=>x.frCode == frCode).length > 0 ? 
      (this.frRolesList.filter(x=>x.frCode == frCode)[0]).longDesc : 'Not available'
    },
    
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_4)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    encrypt(text, i) {
      var CryptoJS = require("crypto-js");
      var encrypted = {};
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(text),
        this.encryptsecret
      );
      encrypted = {
        key: ciphertext.key + "", // don't send this
        iv: ciphertext.iv + "", // don't send this
        salt: ciphertext.salt + "", // don't send this
        ciphertext: ciphertext.ciphertext + "", // don't send this
        str: ciphertext + "" // send or store this
      };
      sessionStorage.setItem("summaryToken", encrypted.str);
      this.$router.push({ name: this.url });
    },
    formatDateTime(dt, splitter){ 
      console.log(dt)
      var dateArray = (dt.split(splitter)[0]).split('-')
      var timeArray = (dt.split(splitter)[1]).split(':')
      var date = dateArray[2]
      var month = dateArray[1]
      var year = dateArray[0] 
      var h = timeArray[0]
      var m = timeArray[1]
      
      var ampm = (h >= 12) ? "PM" : "AM"
      h = ((h > 12) ? h-12 : h)
      h = (h.toString()).length == 1 ? ('0'+h) : h
      return (date + '-' + month + '-' + year) + ' ' + h + ":" + m + " " + ampm;
    },
    decryptfunction() {
      var self = this
      var CryptoJS = require("crypto-js");
      var token = sessionStorage.getItem("summaryToken");
      self.companyCodeToPass = sessionStorage.getItem("companyCode");
      var bytes = token && CryptoJS.AES.decrypt(token.toString(), atob(process.env.VUE_APP_S_S));
      var decryptedData = bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptedData) {
      this.answerNumber = decryptedData.decodedRequestNumber;
      this.userId = decryptedData.eipUsersUserid;
      this.userCode = decryptedData.evaluatorsFRCode;
      this.eipUserName = decryptedData.eipUserName;
      this.auditNo = decryptedData.auditNumber;  
      }      
      
      summaryService.getReportsAdminApplicable(this.companyCodeToPass, decryptedData.eipActualUserId).then(res => {
        this.loading = false;
          if (res.status == "SUCCESS") {
            self.allowViewReportsDashboard = res.response
          } else {
            window.alert('Access Denied!. You are not allowed to access the requested page. please contact support')
            window.close()
          }
        })
        .catch(err => {
          this.loading = false;
            window.alert('Something went wrong. Try again later.');
        });
    },
    logout() {
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(this.auditNo);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      summaryService.userLogout(data)
        .then(res => {
          sessionStorage.clear();
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        })
        .catch(err => {
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    }
  }
};
</script>

<style scoped>
</style>
<style>
.top-btn{
  border-radius: 0px;
  font-size: 16px;
  font-weight: bold;
  padding: 5px 20px;
}
.model-content {
  width: 100% !important;
}
.modal-header {
  font-family: "Source Sans Pro", sans-serif;
  padding: 2% !important;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-footer > .btn-primary {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  text-align: center;
  color: white !important;
  /* border-radius: 2px; */
  background-color: #1579ab;
}
.summaryNavbar {
  background-color: #14436a;
}
.approverButton {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.approverstatus {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  margin-left: 40%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.role-Name {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10% !important;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 2%;
}
.dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.popOverRemarks {
  cursor: pointer;
  float: left;
  font-size: 12px;
  color: #747474;
  text-decoration: underline;
  outline: none !important;
}
.popOverDate {
  float: left;
  font-size: 12px;
  color: #747474;
}
.vgt-table th{  
  padding: 5px 10px !important;
    font-size: 14px !important;
    background-color: #1a72ab !important;
    background: #1a72ab !important;
    color:#fff !important;
}
table.vgt-table td{
  padding: 5px 10px !important;
    font-size: 14px !important;
}
table.vgt-table tr:nth-child(even) {background-color: #f2f2f2;}
.footer__row-count__select{
  width: 30px !important;
  padding: 5px !important;
}
.custom-btn{padding:0px 10px; 
          background-color:#09599a;}
#vendor-details, #workflow-history{
     max-width: 250px;
    display: inline-block;
}
.query-pane button{
    background-color: #09599a;
    margin-left:10px;
    height: 32px;
    margin-top: -4px;
}
.wb-head{
  text-align: left;
    padding-left: 25px;
    font-size: 20px;
    font-weight: bold;
}
.modal-fullscreen{
  max-width: 100%;
}
.modal-fullscreen .modal-dialog{
  width:100% !important;
  max-width: 100% !important;
}

.modal-fullscreen .modal-dialog .modal-content{
  width:95% !important;
}
.wf-history-table{
  width: 100%;
}
.wf-history-table td{
  padding:10px;
}
.text-green{
  color:green;
  font-weight: bold;
}
.text-red{
  color:red;
  font-weight: bold;
}
.text-yellow{
  color:#dec300;
  font-weight: bold;
}
.text-orange{
  color:orange;
  font-weight: bold;
}
.bold{
  font-weight: bold;
}
.trace-wrap{
  height: 20px;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    text-overflow: ellipsis;
}
.trace-wrap div{
  overflow: hidden;
    text-overflow: ellipsis;
}

.linker{
    float: right;
    padding-right: 22px;
    font-weight: bold;
    color: #005aff;
    font-size: 18px;
    text-decoration: underline;
    cursor: pointer;
}
.vgt-table th, .vgt-table td{max-width: 400px !important;overflow: auto;word-break: break-all;}
.vgt-fixed-header{display: none !important;}

.disabled{
  pointer-events: none;
  cursor: default;
  cursor: not-allowed !important;
  opacity: 0.6;  color:#000;  
}

.down-btn{
    padding: 2px 10px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background:#1ae347 !important;
}
.field-heads{
  font-weight: bold;
    text-align: left;
    padding-bottom: 5px;
}
#main-wrapper{
  margin: 15px;
    background: #e3eafd;
    padding: 20px;
    box-shadow: 1px 4px 10px #b6bbb5;
    box-shadow: 0px -3px 10px #ccb;
}
.down-btn:hover{color: #fff;
  background: #1e7e34 !important;
}
  .mx-datepicker-footer{
    text-align: center !important;
  }
  .mx-datepicker-btn-confirm{
    color:#fff !important;
    background: #005aff !important;
  }

  select.sl,.mx-input{
    height: 38px !important;
    border: 2px solid #0958ad !important
  }
  .time-dis{
    background: #079198; 
    padding: 5px 12px;color:#fff;font-style: italic;
    border-radius: 15px;
  }
  .time-dis-wrap{
    font-weight: bold;font-size:16px;margin-bottom: 15px;padding:8px;
        box-shadow: 0px 2px 10px #ccc;    
    background: #ccd6db70;
  }
</style>